import React, { useEffect, useMemo, useState } from "react";
import { createPortal } from "react-dom";

export function HalloweenBlurPage({
                                      anchorId,
                                      blur = 40,            // сила блюра (px)
                                      opacity = 0.64,       // прозрачность затемнения
                                      color = [19, 19, 22], // RGB фон поверх blur
                                      zIndex = 2,        // перекрыть всё
                                  }) {
    const [anchorFound, setAnchorFound] = useState(false);

    // создаём контейнер для портала один раз
    const container = useMemo(() => {
        if (typeof document === "undefined") return null;
        const el = document.createElement("div");
        el.setAttribute("data-holiday-overlay", "halloween-blur");
        el.style.position = "fixed";
        el.style.inset = "0";
        el.style.pointerEvents = "auto";
        return el;
    }, []);

    // следим за появлением/исчезновением якоря
    useEffect(() => {
        if (typeof document === "undefined") return;
        const find = () => setAnchorFound(!!document.getElementById(anchorId));
        find();
        const mo = new MutationObserver(find);
        mo.observe(document.documentElement, { childList: true, subtree: true });
        return () => mo.disconnect();
    }, [anchorId]);

    // монтируем/снимаем контейнер в body
    useEffect(() => {
        if (!container) return;
        if (anchorFound) {
            document.body.appendChild(container);
            return () => {
                try { container.remove(); } catch {}
            };
        }
    }, [anchorFound, container]);

    // блокируем скролл, когда оверлей активен
    useEffect(() => {
        if (!anchorFound || typeof document === "undefined") return;

        const { documentElement, body } = document;
        const scrollBarW = window.innerWidth - document.documentElement.clientWidth;

        const prevHtmlOverflow = documentElement.style.overflow;
        const prevBodyOverflow = body.style.overflow;
        const prevBodyPaddingRight = body.style.paddingRight;

        documentElement.style.overflow = "hidden";
        body.style.overflow = "hidden";
        if (scrollBarW > 0) body.style.paddingRight = `${scrollBarW}px`;

        return () => {
            documentElement.style.overflow = prevHtmlOverflow;
            body.style.overflow = prevBodyOverflow;
            body.style.paddingRight = prevBodyPaddingRight;
        };
    }, [anchorFound]);

    if (!container || !anchorFound) return null;

    const background = `rgba(${color[0]}, ${color[1]}, ${color[2]}, ${opacity})`;

    const overlay = (
        <div
            role="presentation"
            style={{
                position: "fixed",
                inset: 0,
                width: "100%",
                height: "100%",
                background,
                backdropFilter: `blur(${blur}px)`,
                WebkitBackdropFilter: `blur(${blur}px)`,
                zIndex,
            }}
        />
    );

    return createPortal(overlay, container);
}
